import { I01EVACONSSYSTECS2_State } from '@batical/types/src'

const I01EVACONSSYSTECS2: I01EVACONSSYSTECS2_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_typeCalcul: 0,
  coeffMajoration_uuid: 'ecs3',
  in_pourcentLpointe: 0.6,
  in_dureeHPointe: 5.0,
  in_tempsEntrePointe: 2.0,
  in_content: 3.0,
  in_evier: 0.0,
  in_lavabo: 0.0,
  in_bidet: 0.0,
  in_baignoire: 0.0,
  in_douche: 0.0,
  in_robinetdemi: 0.0,
  in_robinetquart: 0.0,
  in_lavemain: 0.0,
  in_baclaver: 0.0,
  in_linge: 0.0,
  in_vaiselle: 0.0,
  in_tempFroide: 20.0,
  in_tempChaude: 40.0,
  in_departPrimaire: 55.0,
  in_nombreElementPickerData: 0.0,
  in_retourPrimaire: 16.0,
  in_volumeTypeECS: 0.0,
  res_S: 0.0,
  res_debit10mn: 0.0,
  res_debitMinute: 0.0,
  res_debitSeconde: 0.0,
  res_puissanceTypeECS: 0.0,
  res_consommationJournaliere: 0.0,
  res_puissanceNecessaire: 0.0,
  res_modeCoupleECS: '',
  res_maxVolumeTypeECS: 0.0,
  mode: 'none',
  calcul_code: 'I01EVACONSSYSTECS2'
}

export default I01EVACONSSYSTECS2
